import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { first } from 'rxjs/operators';
import { ApiService } from '../../../_services/api.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';

@Component({
  selector: 'app-invoice-verification',
  templateUrl: './invoice-verification.component.html',
  styleUrls: ['./invoice-verification.component.scss']
})
export class InvoiceVerificationComponent implements OnInit {

  id: any;
  response: any;
  invoiceData: any;

  constructor(private route: ActivatedRoute,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService) {
    if (this.route.snapshot.paramMap.get('id')) {
      this.id = this.route.snapshot.paramMap.get('id');
      console.log("25", this.id)
    }
  }

  ngOnInit() {

    if (this.id ) {
      this.getInvoiceData();
    } 

  }


  
  getInvoiceData() {
    var data = {
      payment_id: this.id
    }
    this.ngxUiLoaderService.start();
    this.api.invoiceVerificationCheckQr(data).pipe(first())
      .subscribe(data => {
          console.log(data)
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.invoiceData = this.response.result;
            console.log("this.invoiceData",this.invoiceData)
          } else {
            this.invoiceData = '';
          }

        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  // Helper method to get payment status class
  getPaymentStatusClass(): string {
    if (!this.invoiceData.payment_status) {
      return '';
    }
    
    const status = this.invoiceData.payment_status;
    if (status == 5) {
      return 'status-both';
    } else if (status == 3) {
      return 'status-cnss';
    } else if (status == 4) {
      return 'status-cnamgs';
    }
    return '';
  }

  // Helper method to get payment status text
  getPaymentStatusText(): string {
    if (!this.invoiceData.payment_status) {
      return 'Statut inconnu';
    }
    
    const status = this.invoiceData.payment_status;
    if (status == 5) {
      return 'CNSS et CNAMGS Payés';
    } else if (status == 3) {
      return 'CNSS Seulement Payé';
    } else if (status == 4) {
      return 'CNAMGS Seulement Payé';
    }
    return 'Statut inconnu';
  }

  // Helper method to check if CNSS payment exists
  hasCNSSPayment(): boolean {
    if (!this.invoiceData.payment_status) {
      return false;
    }
    const status = this.invoiceData.payment_status;
    return status == 3 || status == 5;
  }

  // Helper method to check if CNAMGS payment exists
  hasCNAMGSPayment(): boolean {
    if (!this.invoiceData.payment_status) {
      return false;
    }
    const status = this.invoiceData.payment_status;
    return status == 4 || status == 5;
  }

  // Helper method to format date
  formatDate(dateString: string): string {
    if (!dateString) return '--';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Helper method to format amount
  formatAmount(amount: string): string {
    if (!amount) return '--';
    const numAmount = parseFloat(amount);
    return new Intl.NumberFormat('fr-FR').format(numAmount) + ' FCFA';
  }

}
